<template>
  <el-card shadow="never">
    <template slot="header">
      <span class="el-card__left">{{ mode === 'edit' ? '修改' : '' }}企业信息</span>
      <el-button
        v-if="mode === 'detail'"
        type="primary"
        @click="mode = 'edit'"
      >修改信息</el-button>
    </template>

    <company-form
      :value="user || {}"
      :mode="mode"
      submit-text="提交修改"
      :loading="isLoading"
      @submit="submit"
    />
  </el-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import CompanyForm from '@/components/CompanyForm'

import { updateCompanyInfo } from '@/api'

export default {

  components: {
    CompanyForm
  },
  data() {
    return {
      mode: 'detail', // detail edit

      isLoading: false
    }
  },

  computed: {
    ...mapState([
      'user'
    ])
  },

  methods: {
    ...mapActions([
      'uploadUserInfo'
    ]),

    /*
     * 提交修改
     */
    async submit(form) {
      this.isLoading = true

      try {
        await updateCompanyInfo({
          companyName: form.name,
          userCategory: form.category,
          foundedTime: form.foundedTime,
          taxesNum: form.taxpayerNumber,
          legalRepresentatives: form.representative,
          creditCode: form.creditCode,
          businessScope: form.scope,
          businessRegister: form.registrationNumber,
          reallyCapital: form.paidCapital,
          registerCapital: form.registrationCapital,
          registerAddress: form.address,
          briefing: form.introduction,
          businessLicense: form.license,
          accessory: form.attachment
        })
        await this.uploadUserInfo()

        this.mode = 'detail'
        this.$message.success('保存成功！')
      } catch (error) {
        this.$message.error(error.message)
      }

      this.isLoading = false
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
